const privacyPolicy = {
  title: "Πολιτική Απορρήτου",
  sections: [
    {
      heading: "1. Εισαγωγή",
      paragraphs: [
        'Η Elite Dental Solutions ("εμείς," "μας," ή "μας") σέβεται την ιδιωτικότητά σας και δεσμεύεται να προστατεύει τα προσωπικά σας δεδομένα.',
        "Αυτή η πολιτική απορρήτου εξηγεί πώς συλλέγουμε, χρησιμοποιούμε και προστατεύουμε τις προσωπικές σας πληροφορίες όταν χρησιμοποιείτε την ιστοσελίδα και τις υπηρεσίες μας.",
      ],
    },
    {
      heading: "2. Πληροφορίες που Συλλέγουμε",
      paragraphs: ["Συλλέγουμε πληροφορίες που μας παρέχετε άμεσα, συμπεριλαμβανομένων:"],
      bullets: [
        "Ονοματεπώνυμο και στοιχεία επικοινωνίας",
        "Ιατρικό και οδοντιατρικό ιστορικό",
        "Αιτήματα ραντεβού και προτιμήσεις",
        "Επικοινωνία μαζί μας",
        "Πληροφορίες πληρωμής",
      ],
    },
    {
      heading: "3. Πώς Χρησιμοποιούμε τις Πληροφορίες Σας",
      paragraphs: ["Χρησιμοποιούμε τις πληροφορίες σας για:"],
      bullets: [
        "Παροχή οδοντιατρικών υπηρεσιών και επεξεργασία ραντεβού",
        "Επικοινωνία σχετικά με τη θεραπεία σας",
        "Αποστολή υπενθυμίσεων για ραντεβού",
        "Επεξεργασία πληρωμών",
        "Βελτίωση των υπηρεσιών μας",
        "Συμμόρφωση με νομικές υποχρεώσεις",
      ],
    },
    {
      heading: "4. Προστασία Δεδομένων",
      paragraphs: [
        "Εφαρμόζουμε κατάλληλα μέτρα ασφαλείας για να προστατεύσουμε τις προσωπικές σας πληροφορίες από μη εξουσιοδοτημένη πρόσβαση, αποκάλυψη, αλλοίωση ή καταστροφή. Οι ιατρικές σας πληροφορίες διαχειρίζονται σύμφωνα με τους ισχύοντες νόμους και κανονισμούς για την ιδιωτικότητα στην υγειονομική περίθαλψη.",
      ],
    },
    {
      heading: "5. Τα Δικαιώματά Σας",
      paragraphs: ["Έχετε το δικαίωμα να:"],
      bullets: [
        "Προσπελάσετε τις προσωπικές σας πληροφορίες",
        "Διορθώσετε ανακριβείς πληροφορίες",
        "Ζητήσετε τη διαγραφή των πληροφοριών σας",
        "Αντιταχθείτε στην επεξεργασία των πληροφοριών σας",
        "Λάβετε ένα αντίγραφο των πληροφοριών σας",
      ],
    },
    {
      heading: "6. Cookies και Παρακολούθηση",
      paragraphs: [
        "Η ιστοσελίδα μας χρησιμοποιεί cookies και παρόμοιες τεχνολογίες παρακολούθησης για να βελτιώσει την εμπειρία περιήγησής σας. Μπορείτε να ελέγξετε τις ρυθμίσεις των cookies μέσω των προτιμήσεων του προγράμματος περιήγησής σας.",
      ],
    },
    {
      heading: "7. Στοιχεία Επικοινωνίας",
      paragraphs: [
        "Για ερωτήσεις σχετικά με αυτή την πολιτική απορρήτου ή τις πρακτικές μας για την ιδιωτικότητα, επικοινωνήστε μαζί μας στο:",
        "Email: info@elitedentalsolutions.com",
        "Τηλέφωνο: +359 897 800 430",
      ],
    },
    {
      heading: "8. Ενημερώσεις σε Αυτή την Πολιτική",
      paragraphs: [
        "Μπορεί να ενημερώνουμε αυτή την πολιτική απορρήτου από καιρό σε καιρό. Η πιο πρόσφατη έκδοση θα είναι πάντα διαθέσιμη στην ιστοσελίδα μας.",
        "Τελευταία ενημέρωση:",
      ],
      lastUpdatedLocale: "el-GR",
    },
  ],
};

export default privacyPolicy;

